import React, {useContext} from 'react';
import { ProductContext } from '../ProductProvider';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { useSnackbar } from 'notistack';
import VJLOGO from '../assets/logo/logo512.png';
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";

export default function Navbar() {
    const { loggedUser, setLoggedUser, myProfileImage, handleImageError } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const navigate=useNavigate();

    const handleSignOut=async(event)=>{
      //console.log("inside sighout");
      try{
          await signOut()
          .then((res)=>{
            console.log("res", res);
          setLoggedUser({...loggedUser,
            name:'',
            email:'',
           // currentStatus:'',
            DOB:'',
            profile:'',
            provinceName:'',
            website:'',
            isAuthenticated:false,
            isAdmin:false
          }); 
          navigate("/login");    
        }).catch((error)=>{
          //console.log("error", error);
          navigate("/");
          enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        })
      }catch(error){
        //console.log("error", error);
        navigate("/");
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      }
    }

  return (
    <div>
    <header className=" " style={{background: 'linear-gradient(90deg, #063547 60%, #7ee8fa 100%)', boxShadow: '0 2px 12px rgba(6,53,71,0.10)', position: 'sticky', top: 0, zIndex: 1050}}>
      <div className="container-fluid px-1">
        <nav className="navbar navbar-expand-lg custom_nav-container py-1" style={{minHeight: 48}}>
          <a className="navbar-brand d-flex align-items-center gap-2" href="https://library.vidyajyoticollege.in" style={{color: '#fff', fontWeight: 900, fontSize: '1.18rem', letterSpacing: 1, textShadow: '0 2px 8px rgba(6,53,71,0.18), 0 0 2px #000', padding: 0, margin: 0, whiteSpace: 'nowrap'}}>
            <img src={VJLOGO} style={{width:"34px", height:"34px", maxWidth: '9vw', maxHeight: '9vw', borderRadius: '6px', boxShadow: '0 2px 8px rgba(6,53,71,0.13)', marginRight: 12, marginLeft: 4, minWidth: 28, minHeight: 28}} alt='Logo'/>
            <span className="d-none d-sm-inline" style={{marginLeft: 6, fontWeight: 900, fontSize: '1.18rem', letterSpacing: 1, color: '#fff', textShadow: '0 2px 8px rgba(6,53,71,0.18), 0 0 2px #000'}}>INIGO <span style={{fontWeight: 700, fontSize: '1.01rem', color: '#e3f6fc', textShadow: '0 1px 4px rgba(6,53,71,0.10)'}}>Library</span></span>
            <span className="d-inline d-sm-none" style={{marginLeft: 6, fontWeight: 900, fontSize: '1.01rem', color: '#fff', textShadow: '0 2px 8px rgba(6,53,71,0.18), 0 0 2px #000'}}>Library</span>
          </a>
          <button className="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{border: 'none', background: 'transparent', color: '#fff', fontSize: 28, padding: 4}}>
            <span className="navbar-toggler-icon" style={{filter: 'invert(1)'}}></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto align-items-lg-center" style={{gap: '0.35rem'}}>
              <li className="nav-item active">
                <Link to="/" className="nav-link px-2" style={{color: '#fff', fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, transition: 'background 0.2s', padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>
                  Home
                </Link>
              </li>
              {/*<li className="nav-item">
                <Link to="/aboutus" className="nav-link px-2" style={{color: '#fff', fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, transition: 'background 0.2s', padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/categories"><a className="nav-link" href="#">Categories</a></Link>
              </li>*/}
              <li className="nav-item">
                <Link to="/search" className="nav-link px-2" style={{color: '#fff', fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, transition: 'background 0.2s', padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>
                  Search
                </Link>
              </li>
              {/*<li className="nav-item">
                <Link to="/contactus"><a className="nav-link" href="#">Contact Us</a></Link>
              </li>*/}
              {loggedUser.isAdmin && 
                <li className="nav-item dropdown">
                  <a className="dropdown-toggle nav-link px-2" data-bs-toggle="dropdown" style={{color:"#fff", fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, cursor:"pointer", padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>Admin</a>
                  <ul className="dropdown-menu dropdown-menu-end mt-2" style={{minWidth: 150, borderRadius: 7, boxShadow: '0 2px 8px rgba(6,53,71,0.10)', fontSize: '0.87rem', padding: '2px 0'}}>
                    <li><Link to="/issuebooks" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Issue Books</Link></li>
                    <li><Link to="/returnbooks" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Return Books</Link></li>
                    <li><Link to="/managebooks" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Manage Books</Link></li>
                    <li><Link to="/barcode" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Barcode Print</Link></li>
                    <li><Link to="/reports" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Reports</Link></li>
                    <li><Link to="/manageusers" className="dropdown-item" style={{fontSize: '0.87rem', padding: '4px 12px'}}>Manage Users</Link></li>
                  </ul>
                </li>
              }
              {!loggedUser.isAuthenticated ? (
                <li className="nav-item">
                  <Link to="/login" className="nav-link px-2" style={{color: '#fff', fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, transition: 'background 0.2s', padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>Sign In</Link>
                </li>
              ) : (
                <li className="nav-item dropdown">
                  <a className="dropdown-toggle nav-link px-2 d-flex align-items-center gap-2" data-bs-toggle="dropdown" style={{color:"#fff", fontWeight: 500, fontSize: '0.93rem', borderRadius: 4, cursor:"pointer", padding: '4px 10px', margin: '0 3px', minWidth: 60, textAlign: 'center'}}>
                    <img className="img-responsive rounded-circle profile_image" src={myProfileImage} alt="#" style={{width: 22, height: 22, minWidth: 18, minHeight: 18, objectFit: 'cover', border: '2px solid #e3f6fc', marginRight: 5}}
                    onError={handleImageError} />
                    <span className="d-none d-sm-inline">{loggedUser.name}</span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end mt-2" style={{minWidth: 120, borderRadius: 7, boxShadow: '0 2px 8px rgba(6,53,71,0.10)', fontSize: '0.85rem', padding: '2px 0'}}>
                    <li><Link to="/myprofile" className="dropdown-item" style={{fontSize: '0.85rem', padding: '4px 12px'}}>My Profile</Link></li>
                    <li><Link to="/mybooks" className="dropdown-item" style={{fontSize: '0.85rem', padding: '4px 12px'}}>My Books</Link></li>
                    {/*<li><a className="dropdown-item" href="help.html">Help</a></li>*/}
                    <li><a className="dropdown-item" href="#" onClick={event=>handleSignOut(event)} style={{fontSize: '0.85rem', padding: '4px 12px'}}><span>Log Out</span> <i className="fa fa-sign-out"></i></a></li>
                  </ul>
                </li>
              )}
            </ul>
           {/*} <from className="search_form">
              <input type="text" className="form-control" placeholder="Search here..." />
              <button className="" type="submit">
                <i className="fa fa-search" aria-hidden="true"></i>
              </button>
            </from>*/}
          </div>
        </nav>
      </div>
    </header>
    </div>
  )
}
